export default __webpack_public_path__ + "static/media/logo.bae4ad45.svg";